import { FC } from 'react'
import { AdultCenterCriteria } from 'components/AdultCenterCriteria/AdultCenterCriteria'
import { PediatricCenterCriteria } from 'components/PediatricCenterCriteria/PediatricCenterCriteria'

export const CenterMembershipCriteria: FC = () => {
  return (
    <main className="min-h-screen bg-[#EDE6DE] px-4 py-12 md:px-8 lg:px-16">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-serif text-[#3C2416] mb-6">
          Membership Criteria
        </h1>

        <div className="prose prose-lg max-w-none mb-12">
          <h2 className="text-[#A6410A] font-medium">
            What Your Center Needs to Join
          </h2>
          <p className="text-[#3C2416]">
            There are a few requirements needed to become a member of the NASCC.
            We currently have three different types of centers that we accept as
            members: those who treat adults, those who treat children
            (pediatrics), and those that treat both types of patients. Depending
            on what category you fall into, the requirements to be accepted are
            slightly different. Below, you can see the requirements for each
            type of center. As long you meet most of these criteria, we
            encourage you to apply!
          </p>
          <br />
          <p className="text-[#3C2416]">
            You can also reach out to{' '}
            <a
              href="mailto:applications@sicklecellcenters.org"
              className="text-[#A6410A] hover:underline"
            >
              applications@sicklecellcenters.org
            </a>{' '}
            for more information, if needed.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <AdultCenterCriteria />
          <PediatricCenterCriteria />
        </div>

        {/* Whole Life Center Section */}
        <div className="mt-12 bg-white rounded-lg shadow-lg p-6">
          <h3 className="text-2xl font-serif text-[#3C2416] mb-4">
            Criteria for a Whole Life Center
          </h3>
          <p className="text-[#3C2416]">
            As a whole life treatment center is treating patients from childhood
            to adulthood, NASCC requires that they have a combination of the
            above resources. We encourage you to reach out to{' '}
            <a
              href="mailto:applications@sicklecellcenters.org"
              className="text-[#A6410A] hover:underline"
            >
              applications@sicklecellcenters.org
            </a>{' '}
            for more information, if needed.
          </p>
        </div>
      </div>
    </main>
  )
}

export default CenterMembershipCriteria
